import {
  RESET_SEARCH,
  SEARCH_FAILURE,
  SEARCH_FILTER,
  SEARCH_FOCUS,
  SEARCH_INIT,
  SEARCH_SUCCESS,
  SearchActionTypes,
  SearchState
} from "./types";

const initialState: SearchState = {
  query: "",
  results: [],
  filters: {},
  location: null,
  isSearching: false,
  successSearching: false,
  errorSearching: null,
  focused: false
};

// maps state and action to next value of state
export default function appReducer(
  state = initialState,
  action: SearchActionTypes
) {
  switch (action.type) {
    case SEARCH_FOCUS:
      return {
        ...state,
        focused: action.focus
      };

    case SEARCH_FILTER:
      const newFilters = Object.assign({}, state.filters);
      Object.keys(action.filter).forEach(filterName => {
        if (action.filter[filterName] == null) delete newFilters[filterName];
        else newFilters[filterName] = action.filter[filterName];
      });

      return {
        ...state,
        filters: newFilters
      };

    case SEARCH_INIT:
      return {
        ...state,
        query: action.query,
        isSearching: true,
        successSearching: false,
        errorSearching: null
      };

    case SEARCH_SUCCESS:
      return {
        ...state,
        isSearching: false,
        successSearching: true,
        results: action.results
      };

    case SEARCH_FAILURE:
      return {
        ...state,
        isSearching: false,
        errorSearching: action.error
      };

    case RESET_SEARCH:
      return initialState;

    default:
      return state;
  }
}
